import zh from './ZH';
import es from './Spanish'; //西班牙

let Dics = {
    zh, es
}

export default function Tr(key, par){
    let language = window.selectedLanguage || 'zh';
    let dic = Dics[language];
    if(!dic[key]) {
        return (Dics['zh'][key] || key);
    }
    return (dic[key] || '').replace(/\$var/, par);
}
